export const customQueryParamsSerializer = (params) => {
    const queryStrings = []
    for (const [key, value] of Object.entries(params)) {
        const isStr = typeof value === 'string' || typeof value === 'number'

        if (isStr) {
            queryStrings.push(`${key}=${value}`)
            continue
        }

        const isArrayStr = Array.isArray(value) && (typeof value[0] === 'string')
        if (isArrayStr) {
            value.forEach(v => queryStrings.push(`${key}=${v}`))
            continue
        }

        console.error("invalid query params", key, value)
    }

    return queryStrings.join("&")
}